import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { isStaticSnapshotHost, toLiveOrigin } from "@/lib/api";

if (isStaticSnapshotHost()) {
  const { origin, pathname, search, hash } = window.location;
  window.location.replace(toLiveOrigin(origin) + pathname + search + hash);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
